module.exports = __webpack_public_path__ + "static/media/013.b4663bcc.jpg";